import { boxPlanningKeys } from "@/modules/boxPlanning/gateway/boxPlanningKeys"
import { boxSlotSessionKeys } from "@/modules/boxSlotSession/gateway/boxSlotSessionKey"
import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useB2BProgramActions = () => {
  const { boxB2BProgramApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: importProgramMutation, isPending } = useMutation({
    mutationFn: async ({
      boxProgramId,
      programId,
      startDate,
      endDate,
    }: {
      boxProgramId: string
      programId: string
      startDate: Date
      endDate: Date
    }) => {
      await boxB2BProgramApi.duplicateB2BProgramSessions(boxProgramId, programId, startDate, endDate)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: boxSlotSessionKeys.all })
      queryClient.invalidateQueries({ queryKey: boxPlanningKeys.slots() })
    },
  })

  return {
    importProgramMutation,
    isPending,
  }
}
